const widgetsModule = {
  state: {
    items: null,
    pagination: null,
    default_options: null,
    widgets_abtests: null,
    all_widgets: null,
    allowed_widget_types: [
      {
        name: 'widget.smart_offer',
        value: 'smart_offer',
        widget_types: [
          {
            name: 'Coupon'
          },
          {
            name: 'Smartoffer_Desktop'
          },
          {
            name: 'Smartoffer_Mobile_v2'
          },
          {
            name: 'Scratch'
          },
          {
            name: 'Wheel_Of_Fortune'
          },
          {
            name: 'Wheel_Of_Fortune_mobile'
          }
        ]
      },
      {
        name: 'widget.notification',
        value: 'notification',
        widget_types: [
          {
            name: 'Notification'
          },
          {
            name: 'Social_Proof'
          },
          {
            name: 'Average_Check_Enlarger'
          },
          {
            name: 'Average_Check_Enlarger_v2'
          },
          {
            name: 'Abandoned_Cart'
          }
        ]
      },
      {
        name: 'widget.recommendations',
        value: 'recommendations',
        widget_types: [
          {
            name: 'Рекомендации'
          },
          {
            name: 'Last_Viewed'
          }
        ]
      },
      {
        name: 'widget.subscribe',
        value: 'subscribe',
        widget_types: [
          {
            name: 'Subscribe'
          },
          {
            name: 'News_Subscription_2_steps'
          },
          {
            name: 'News_Subscription_3_steps'
          },
          {
            name: 'News_Subscription'
          }
        ]
      },
      {
        name: 'widget.wish_list',
        value: 'wish_list',
        widget_types: [
          {
            name: 'wish_list_noframe'
          }
        ]
      },
      {
        name: 'widget.generic',
        value: 'generic',
        widget_types: [
          {
            name: 'Generic'
          }
        ]
      }
    ]
  },
  mutations: {
    setWidgets(state, data) {
      state.items = data
    },
    setWidgetsPagination(state, data) {
      state.pagination = data
    },
    setWidget(state, widget) {
      state[widget.id] = widget
    },
    setWidgetsDefaultOptions(state, default_options) {
      state.default_options = default_options
    },
    setWidgetsABtests(state, widgets_abtests) {
      state.widgets_abtests = widgets_abtests
    },
    setAllWidgets(state, data) {
      state.all_widgets = data
    }
  },
  getters: {
    getWidgets: (state) => {
      return state.items
    },
    getWidgetById: (state) => (id) => {
      let index = state.items.findIndex(function (item) {
        if (item.id === id) return true
        else return false
      })
      if (index !== -1) {
        return state.items[index]
      } else {
        return null
      }
    },
    getWidgetByIdInEditor: (state) => (id) => {
      return state[id]
    },
    getWidgetsPagination: (state) => {
      return state.pagination
    },
    getWidgetsDefaultOptions: (state) => {
      return state.default_options
    },
    getWidgetsABtests: (state) => {
      return state.widgets_abtests
    },
    getAllWidgets: (state) => {
      return state.all_widgets
    },
    allowed_widget_types: (state) => {
      return state.allowed_widget_types
    },
    getOvertypeByType: (state) => (type_name) => {
      let index_overtype = state.allowed_widget_types.findIndex(function (overtype) {
        let index_type = overtype.widget_types.findIndex(function (type) {
          if (type_name === type.name) return true
          else return false
        })
        if (index_type !== -1) {
          return true
        } else return false
      })
      if (index_overtype !== -1) {
        return state.allowed_widget_types[index_overtype]
      } else {
        return null
      }
    }
  }
}

export default widgetsModule



// WEBPACK FOOTER //
// ./src/store/modules/widgets.js